const normalizeRayoloDiscount = (badge) => {
  if (badge.getAttribute("discount-mode") === "percentage") return;
  const current = badge.textContent.trim();
  const match = current.match(/^Économisez\s*€\s*([\d\s.,\u00a0]+)$/i);
  if (!match) return;
  const amount = match[1].trim().replace(/,00$/, "");
  badge.textContent = `Économisez ${amount} €`;
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("on-sale-badge").forEach((badge) => {
    normalizeRayoloDiscount(badge);
    new MutationObserver(() => normalizeRayoloDiscount(badge)).observe(badge, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });
});
